import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import { APPLICATION_NAME, RODEO_PAGE_NAME } from "src/_config";
import TaskDetailsPage from "src/components/events/taskDetails/taskDetailsPage";

export default function RodeoEventTaskDetailsContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Event List`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <Sidebar page={RODEO_PAGE_NAME.EVENT_GAME_LIST} />
      <section className="main-container">
        <TaskDetailsPage />
      </section>
    </React.Fragment>
  );
}
